import { BlockInteractionsState, ButtonKeys, ButtonsType } from '../BlockInteractionsTypes';
import { ButtonType } from '../../../../types/ButtonType';

type EditViewType = {
  state: BlockInteractionsState;
  buttons?: ButtonsType;
};
/**
 * The edit view is always provided via the `buttons` prop and needs to rendered
 * inside of the `block-interactions__content` div.
 *
 * NOTE the Members.manage view conceptioally is its edit view.
 */
export function EditView({ state, buttons }: EditViewType) {
  const { primaryView } = state;
  if (buttons && ['edit', 'manage'].includes(primaryView)) {
    return buttons[primaryView as keyof Record<ButtonKeys, ButtonType>]?.View || null;
  }
  return null;
}
